"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgIrFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("circle", { cx: 16, cy: 1.5, r: 1.5 }),
        React.createElement("circle", { cx: 16, cy: 7.5, r: 1.5 }),
        React.createElement("circle", { cx: 16, cy: 13.5, r: 1.5 }),
        React.createElement("path", { d: "M22.56 18H9.44A3.44 3.44 0 006 21.44V30h20v-8.56A3.44 3.44 0 0022.56 18z" })));
}
exports.default = SvgIrFilled;
//# sourceMappingURL=IrFilled.js.map